import { isURL, getRootDomain } from '../url'

const getAuth0 = (): Auth0Client => window.__auth0__ || window.auth0
export default getAuth0

function getContinueTo(search: string, browseUrl: string): string {
  const params = new URLSearchParams(search)
  const continueTo = params.get('continueTo') || document.referrer

  if (continueTo?.startsWith('/')) return new URL(continueTo, browseUrl).href
  if (continueTo === '' || !isURL(continueTo)) return browseUrl
  const url = new URL(continueTo)
  if (getRootDomain(url) === getRootDomain(new URL(browseUrl))) return url.href
  return browseUrl
}

export function getBrowseRedirectUri(search: string): string {
  const browseUrl = window.location.origin
  const continueTo = getContinueTo(search, browseUrl)
  return `${browseUrl}/sso/browse/callback?continueTo=${encodeURIComponent(continueTo)}`
}
